import moment from "moment";

export const INITIAL_STATE = {
  customerId: "HCF0245",
  loginEmailId: "",
  productId: "",
  groupId: "",
  pbpId: "",
  planId: "",
  electionType: "",
  prefix: "",
  firstName: "",
  lastName: "",
  suffix: "",
  middleInitial: "",
  birthDate: "",
  sex: "",
  primaryPhone: "",
  cellPhone: "         ",
  permanentAddrStreet: "",
  permanentAddrApt: "",
  permanentCounty: "",
  permanentCity: "",
  permanentState: "",
  permanentZip: "",
  mailingAddressRequired: "",
  mailingAddr: "",
  mailingCity: "",
  mailingState: "",
  mailingzip: "",
  emailAddr: "",
  emailAlert: "",
  callAlert: "",
  medicareClaim: "",
  hospitalPartA: "",
  hospitalPartB: "",
  paymentOption: "D",
  acctholdername: "",
  bankname: "",
  acctType: "",
  routingNumber: "",
  accountNumber: "",
  monthlybf: "",
  renalDisease: "",
  esrdcontact: "",
  vaBenefits: "N",
  nameOfCov: "",
  idOfCov: "",
  groupOfCov: "",
  medicaidprg: "",
  medicaidNbr: "",
  prescriptionDrug: "",
  nameOfInst: "",
  phoneOfInst: "",
  addrOfInst: "",
  spousework: "",
  pcpName: "",
  pcpMedicalGroupName: "",
  existingp: "",
  language: "",
  languageValue: "",
  aep: "",
  c1: "",
  c2: "",
  attestation2: "",
  c3: "",
  attestation3: "",
  c4: "",
  attestation4: "",
  c5: "",
  attestation5: "",
  c6: "",
  c7: "",
  c8: "",
  attestation8: "",
  c9: "",
  attestation9: "",
  c10: "",
  attestation10: "",
  c11: "",
  attestation11: "",
  c12: "",
  attestation12: "",
  c13: "",
  c14: "",
  c15: "",
  attestation15: "",
  c16: "",
  c16Attestation: "",
  attestation16: "",
  coveragebegin: "",
  nameSignature: "",
  digitalSignature: "",
  todaysDate: moment().format("MM/DD/YYYY"),
  authorizedrepname: "",
  authorizedreprelationship: "",
  authorizedrepaddress: "",
  authorizedrepphone: "",
  nameAgent: "",
  agentLicense: "",

  //ssn:"",
  effDate: "",
  retiree: "",
  retiredate: "",
  retirename: "",
  meddependsp: "",
  dependentSpouse: "",
  dependentOther: "",
  hlthcovType: "",
  hlthcovInscomp: "",
  c20: "",
  c21: "",
  attestation21: "",
  c22: "",
  attestation22: "",
  c23: "",
  attestation23: "",
  c24: "",
  attestation24: "",
  c25: "",
  attestation25: "",
  ssn: "",
  planYear: "",
  coveringSpouseOrDependent: "",
  coveringSpouseOrDependentLastName: "",
  coveringSpouseOrDependentFirstName: "",
  coveringSpouseOrDependentMiddleName: "",
  coveringSpouseOrDependentEmployeeName: "",
  survivingSpouseCitySanDiegoRetiree: "",
  survivingSpouseCitySanDiegoRetireeLastName: "",
  survivingSpouseCitySanDiegoRetireeFirstName: "",
  survivingSpouseCitySanDiegoRetireeMiddleName: "",
  authorizedRep: "",
  agentAssistingEnrollment: "",

  //Indy
  c_qns1: "",
  otherLanguage: "",
  youwork: "",
  listPCP: "",
  vieEmail: "",
  Formulary: "",
  eoc: "",
  pharmacy: "",
  attestation7:"",
};
